import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';
import type { BrandRow } from '../../../lib/supabase';

export default function AgencyBrands() {
  const [brands, setBrands] = useState<BrandRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      const { data } = await supabase
        .from('agency_brands')
        .select('*')
        .eq('is_active', true)
        .order('sort_order', { ascending: true });
      setBrands(data ?? []);
      setLoading(false);
    };
    fetchBrands();
  }, []);

  if (loading) {
    return (
      <section className="w-full bg-gray-50 py-16 px-4">
        <div className="max-w-5xl mx-auto flex justify-center">
          <i className="ri-loader-4-line text-3xl text-gray-300 animate-spin" />
        </div>
      </section>
    );
  }

  if (brands.length === 0) return null;

  return (
    <section className="w-full bg-gray-50 py-16 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Section Header */}
        <div className="mb-12">
          <p className="text-xs tracking-[0.35em] text-[#1a73b5] uppercase mb-2">AGENCY BRANDS</p>
          <div className="flex items-center gap-3">
            <div className="w-1 h-8 bg-[#1a73b5]" />
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-wider">代理品牌</h2>
          </div>
          <p className="mt-4 text-gray-500 text-sm leading-relaxed max-w-xl">
            益維長期深耕歐美知名工業品牌代理，為台灣各產業提供高品質、高可靠度的設備與解決方案。
          </p>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="bg-white border border-gray-100 rounded-lg p-6 flex flex-col items-center text-center transition-transform duration-200 hover:-translate-y-1"
            >
              <div className="w-full h-[100px] flex items-center justify-center mb-5">
                {brand.logo_url ? (
                  <img
                    src={brand.logo_url}
                    alt={brand.name}
                    className="max-h-[90px] max-w-full object-contain"
                  />
                ) : (
                  <div className="w-16 h-16 flex items-center justify-center">
                    <i className="ri-building-2-line text-4xl text-gray-200" />
                  </div>
                )}
              </div>
              <div className="w-8 h-px bg-[#1a73b5] mb-3" />
              <p className="text-sm font-semibold text-gray-700 mb-2 leading-snug">{brand.name}</p>
              {brand.description && (
                <p className="text-xs text-gray-500 leading-relaxed">{brand.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
